var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"selectFile":_vm.selectFile,"loading":_vm.loading}),_vm._v(" "),_c('input',{ref:"field",staticClass:"tw-hidden",attrs:{"type":"file"},on:{"change":_vm.upload}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }